'use strict';
const mmWidgets = require('./mm-widgets'),
	validEmail = require('@mindmup/js-utils/src/valid-email'),
	emailRegEx = /<([^>]+)>/,
	emailFromString = (val) => {
		const m = (val && val.match && val.match(emailRegEx));
		if (m && m.length && m.length > 1) {
			return m[1];
		}
		return val;
	};

mmWidgets.fn.goldMapDirectShareWidget = function (mapSharingModel) {
	if (!mapSharingModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this,
			addEmailsButton = element.find('[data-mm-role~="add-emails"]'),
			sharingRoleSelector = element.find('[data-mm-role~="sharing-role-selector"]'),
			emailsToAdd = element.find('[data-mm-role~="emails-to-add"]'),
			getEmailsToAdd = () => {
				const emailslist = emailsToAdd.val(),
					emails = emailslist.split(/[\n\r\s;,]+/).map(emailFromString);
				return (emails && emails.length && emails.filter((email) => validEmail(email))) || [];
			};
		emailsToAdd.on('input change', () => {
			if (getEmailsToAdd().length) {
				addEmailsButton.removeClass('disabled');
			} else {
				addEmailsButton.addClass('disabled');
			}
		});
		addEmailsButton.click(() => {
			let validEmails = getEmailsToAdd();
			const role = sharingRoleSelector.val();
			emailsToAdd.val('').trigger('change');
			if (!validEmails.length) {
				return;
			}
			if (validEmails.length > 10) {
				validEmails = validEmails.slice(0, 10);
			}
			mapSharingModel.addMultiple(validEmails, role);
		});

	});
};
